import { getAllParagraphs } from "./locationUtils";
// FNV-1a 32-bit hash for consistent short ID
function fnv1a32(str) {
    let hash = 0x811c9dc5;
    for(let i = 0; i < str.length; i++){
        hash ^= str.charCodeAt(i);
        hash = hash * 0x01000193 >>> 0;
    }
    return hash.toString(16);
}
// Helper function to generate a bookmark name for headers and lists (without index)
export function getBookmarkName(type, text) {
    const hash = fnv1a32(text);
    return `_${type}_${hash}`;
}
export async function bookmarkAllHeadersAndLists() {
    return Word.run(async (context)=>{
        const paragraphs = await getAllParagraphs(context);
        const bookmarkNames = [];
        for(let i = 0; i < paragraphs.items.length; i++){
            const para = paragraphs.items[i];
            const style = para.style ?? "";
            const text = para.text.trim();
            if (!text) continue;
            // Bookmark all headings (Heading 1, 2, etc.)
            if (/^Heading \d+$/i.test(style)) {
                const name = getBookmarkName("Header", text);
                para.getRange().insertBookmark(name);
                bookmarkNames.push(name);
            } else if (style === "List Paragraph" && /^\d+[.)]/.test(text) // e.g., "1. item" or "2) item"
            ) {
                const name = getBookmarkName("List", text);
                para.getRange().insertBookmark(name);
                bookmarkNames.push(name);
            }
        }
        await context.sync();
        return bookmarkNames;
    });
}
